export const THRESHOLD_UNIT_OPTIONS = [
  { value: 'ppm', label: 'ppm' },
  { value: 'percent_lel', label: '% LIE' },
];

export const THRESHOLD_TYPE_OPTIONS = [
  { value: 'tossicita', label: 'Tossicità' },
  { value: 'esplosivita', label: 'Esplosività' },
];

export const EXTRACT_OPERATION_OPTIONS = [
  { value: '', label: 'Non specificato' },
  { value: 'first_threshold', label: 'Prima soglia' },
  { value: 'second_threshold', label: 'Seconda soglia' },
  { value: 'manual', label: 'Manuale' },
  { value: 'continuous', label: 'Continuo' },
];

export const ABATEMENT_CONTROL_MODE_OPTIONS = [
  { value: '', label: 'Non specificato' },
  { value: 'manuale', label: 'Manuale' },
  { value: 'automatico', label: 'Automatico' },
];

export const LOCATION_OPTIONS = [
  { value: '', label: 'Non specificato' },
  { value: 'interrata', label: 'Interrata' },
  { value: 'fuori_terra', label: 'Fuori terra' },
];

export const SIGNAGE_OPTIONS = [
  { value: '', label: 'Non specificato' },
  { value: 'segnalata', label: 'Segnalata' },
  { value: 'non_segnalata', label: 'Non segnalata' },
];

export const ACCESSIBILITY_OPTIONS = [
  { value: '', label: 'Non specificato' },
  { value: 'agevole', label: 'Agevole' },
  { value: 'difficoltosa', label: 'Difficoltosa' },
];

export const MATERIAL_OPTIONS = [
  { value: '', label: 'Non specificato' },
  { value: 'ca', label: 'Cemento armato' },
  { value: 'acciaio_zincato', label: 'Acciaio zincato' },
  { value: 'vetroresina', label: 'Vetroresina' },
  { value: 'polietilene', label: 'Polietilene' },
];

export const ORIENTATION_OPTIONS = [
  { value: '', label: 'Non specificato' },
  { value: 'orizzontale', label: 'Orizzontale' },
  { value: 'verticale', label: 'Verticale' },
];

export const VVF_DOCS_OPTIONS = [
  { value: '', label: 'Non specificato' },
  { value: 'prevista', label: 'Prevista' },
  { value: 'non_prevista', label: 'Non prevista' },
];
